import { BrowserSearchEngine } from './common'

const defaultFieldSpecifiers = []

const defaultSyntaxGuideUrl = ''

class OpenAccessThesesAndDissertations extends BrowserSearchEngine {
  constructor (fieldSpecifiers) {
    super('Open Access Theses and Dissertations')
    this.fieldSpecifiers = fieldSpecifiers || defaultFieldSpecifiers
    this.syntaxGuideUrl = defaultSyntaxGuideUrl
  }

  formulateQuery (query) {
    return 'https://oatd.org/oatd/search?q=' + query
  }

  lintQuery (queryGraphData) {
    const m = this.lintFieldSpecifiers(queryGraphData, this.fieldSpecifiers)
    return m ? [m] : []
  }

  getSuggestTermsMetaData () {
    return this.getSuggestTermsDbpediaSettings()
  }
}

export default OpenAccessThesesAndDissertations



// WEBPACK FOOTER //
// ./src/formulate_queries/OpenAccessThesesAndDissertations.js